import { useState, useEffect } from "react";
import { LogOut, Shield } from "lucide-react";
import { toast } from "sonner";

/**
 * Fixed red banner shown on top of the app when a super-admin is currently
 * impersonating another user. Clicking "Sair da atuação" clears the header
 * and reloads to restore normal admin session.
 */
export default function ImpersonationBanner() {
  const [email, setEmail] = useState("");

  useEffect(() => {
    try {
      setEmail(localStorage.getItem("impersonate_user_email") || "");
    } catch (_) {}
    // Poll every 2s so if user manually clears localStorage, banner disappears
    const t = setInterval(() => {
      try {
        setEmail(localStorage.getItem("impersonate_user_email") || "");
      } catch (_) {}
    }, 2000);
    return () => clearInterval(t);
  }, []);

  if (!email) return null;

  const stop = () => {
    try {
      localStorage.removeItem("impersonate_user_id");
      localStorage.removeItem("impersonate_user_email");
    } catch (_) {}
    toast.success("Saindo da atuação...");
    setTimeout(() => window.location.reload(), 400);
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-red-600 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-lg"
      data-testid="impersonation-banner"
    >
      <Shield className="w-4 h-4" />
      <span>
        <strong>Modo super-admin ativo</strong> · Atuando como <strong>{email}</strong>
      </span>
      <button
        onClick={stop}
        className="ml-2 bg-white/20 hover:bg-white/30 text-white rounded-md h-7 px-3 text-xs font-mono uppercase tracking-widest inline-flex items-center gap-1"
        data-testid="impersonation-stop"
      >
        <LogOut className="w-3 h-3" /> Sair da atuação
      </button>
    </div>
  );
}
